<template>
  <div class="home">
    <!-- 轮播图 -->
    <div class="glide">
      <div class="glide__track" data-glide-el="track">
        <div class="glide__slides">
          <div class="glide__slide">
            <div class="slide-caption">
              <h1>哈尔滨杰仓信息科技有限公司</h1>
              <h3>
                最好的合作，是双向奔赴，我们不只是提供产品，更是你的技术伙伴。
              </h3>
              <a href="#choose-us"
                ><button class="explore-btn">探索更多</button></a
              >
            </div>
            <div class="backdrop"></div>
            <img src="..\assets\images\glide\glide-1.jpg" />
          </div>
          <div class="glide__slide">
            <div class="slide-caption left">
              <h1>科技的温度，藏在每一次高效的响应里</h1>
              <h3>
                前期深入沟通需求，中期全力保障落地，后期持续提供支持，陪你一起应对变化、解决问题。
              </h3>
              <a href="#choose-us"
                ><button class="explore-btn">探索更多</button></a
              >
            </div>
            <div class="backdrop"></div>
            <img src="..\assets\images\glide\glide-2.jpg" />
          </div>
        </div>
        <div
          class="glide__arrows"
          data-glide-el="controls"
          style="text-align: center"
        >
          <button class="glide__arrow glide__arrow--left" data-glide-dir="<">
            <i class="fa fa-angle-left"></i>
          </button>
          <button class="glide__arrow glide__arrow--right" data-glide-dir=">">
            <i class="fa fa-angle-right"></i>
          </button>
          <div class="glide__bullets" data-glide-el="controls[nav]">
            <button class="glide__bullet" data-glide-dir="=0"></button>
            <button class="glide__bullet" data-glide-dir="=1"></button>
          </div>
        </div>
      </div>
    </div>
    <div class="content-wrapper">
      <!-- 为什么选择我们 -->
      <section id="choose-us" class="choose-us">
        <StatsHeader 
          title="为什么选择我们"
          subtitle="每一次合作都是基于相互信任的价值共创"
        />
        <div class="features">
          <div class="feature">
            <i class="fas fa-lightbulb"></i>
            <h4 class="feature-title">高性能数据库解决</h4>
            <p class="feature-content">
              我们专业的数据库处理系统时刻保障你的数据安全
            </p>
          </div>
          <div class="feature">
            <i class="fas fa-chart-line"></i>
            <h4 class="feature-title">数据库自动运维</h4>
            <p class="feature-content">解放企业DBA双手，减小运维人员工作量</p>
          </div>
          <div class="feature">
            <i class="fas fa-code"></i>
            <h4 class="feature-title">先进的技术栈</h4>
            <p class="feature-content">
              公司始终拥抱前沿科技，为您提供最强大的体验
            </p>
          </div>
          <div class="feature">
            <i class="fas fa-desktop"></i>
            <h4 class="feature-title">良好的兼容性</h4>
            <p class="feature-content">
              针对不同多种数据库设计，兼容多种数据库
            </p>
          </div>
          <div class="feature">
            <i class="fas fa-handshake"></i>
            <h4 class="feature-title">客户广泛</h4>
            <p class="feature-content">
              客户包括银行，电力，银行等多领域，经验丰富
            </p>
          </div>
          <div class="feature">
            <i class="fas fa-globe"></i>
            <h4 class="feature-title">国际化</h4>
            <p class="feature-content">内建业界通用的国际化方案</p>
          </div>
          <div class="feature">
            <i class="fas fa-magic"></i>
            <h4 class="feature-title">最佳实践</h4>
            <p class="feature-content">
              根据我们在此领域的经验帮助你实现项目落地
            </p>
          </div>
          <div class="feature">
            <i class="fas fa-server"></i>
            <h4 class="feature-title">简单部署</h4>
            <p class="feature-content">
              部署简单方便，定制化程度高，具有良好的特性
            </p>
          </div>
          <div class="feature">
            <i class="fas fa-microchip"></i>
            <h4 class="feature-title">测试</h4>
            <p class="feature-content">自动化测试保障我门的产品质量</p>
          </div>
        </div>
      </section>
      <!-- 产品 -->
      <section id="company-product" class="company-product section-bg">
        <StatsHeader 
          title="产品"
          subtitle="不玩概念，只做能解决问题的产品"
        />
        <div class="products">
          <div class="product">
            <div class="product-image-wrapper">
              <img src="..\assets\images\product\product-1.jpg" alt="" />
            </div>
            <h2 class="product-title">数据库审计平台</h2>
            <article>为企业构建一个统一、智能、合规的数据库访问入口。</article>
            <router-link to="/product/database-audit">
              <button class="read-more-btn">了解更多</button>
            </router-link>
          </div>
          <div class="product">
            <div class="product-image-wrapper">
              <img src="..\assets\images\product\product-2.jpg" alt="" />
            </div>
            <h2 class="product-title">运维安全管控平台</h2>
            <article>一款遵循4A安全体系的企业级堡垒机解决方案。</article>
            <router-link to="/product/ops-security">
              <button class="read-more-btn">了解更多</button>
            </router-link>
          </div>
          <div class="product">
            <div class="product-image-wrapper">
              <img src="..\assets\images\product\product-3.jpg" alt="" />
            </div>
            <h2 class="product-title">智能运维管理平台</h2>
            <article>面向大型企业核心系统打造的新一代运维决策中枢。</article>
            <router-link to="/product/ai-ops-platform">
              <button class="read-more-btn">了解更多</button>
            </router-link>
          </div>
          <div class="product">
            <div class="product-image-wrapper">
              <img src="..\assets\images\product\product-4.jpg" alt="" />
            </div>
            <h2 class="product-title">患者信息及生物样本采集管理系统</h2>
            <article>为推进大骨节病专项研究而研发的专业医疗科研平台。</article>
            <router-link to="/product/biosample-mgmt">
              <button class="read-more-btn">了解更多</button>
            </router-link>
          </div>
          <div class="product">
            <div class="product-image-wrapper">
              <img src="..\assets\images\product\product-5.jpg" alt="" />
            </div>
            <h2 class="product-title">自动化运维数字资源管理系统</h2>
            <article>一款面向企业级用户的一体化脚本与介质管理平台。</article>
            <router-link to="/product/auto-ops-resource">
              <button class="read-more-btn">了解更多</button>
            </router-link>
          </div>
        </div>
      </section>
      <!-- 服务 -->
      <CustomerCase />
      <ServiceProcess />
      <!-- 数据展示 -->
      <section class="data-section">
        <div class="data-piece">
          <i class="fas fa-users"></i>
          <div class="num">30＋</div>
          <div class="data-desc">客户数量</div>
        </div>
        <div class="data-piece">
          <i class="fas fa-tachometer-alt"></i>
          <div class="num">2000＋小时</div>
          <div class="data-desc">运行时间</div>
        </div>
        <div class="data-piece">
          <i class="fas fa-layer-group"></i>
          <div class="num">49＋</div>
          <div class="data-desc">运行系统</div>
        </div>
      </section>
    </div>
  </div>
</template>

<script setup>
import ServiceProcess from "../components/ServiceProcess.vue";
import CustomerCase from "@/components/CustomerCase.vue";
import StatsHeader from "../components/StatsHeader.vue";
import { onMounted, onUnmounted } from "vue";
import Glide from "@glidejs/glide";
import anime from "animejs/lib/anime.es.js";
import ScrollReveal from "scrollreveal";
import "@glidejs/glide/dist/css/glide.core.min.css";
import "@glidejs/glide/dist/css/glide.theme.min.css";

// 轮播图
// 存储轮播实例，用于清理
let glideInstance = null;
onMounted(() => {
  // 1. 初始化轮播
  const glide = new Glide(".glide", {
    type: "carousel",
    startAt: 0,
    autoplay: 3500,
    perView: 1,
  });
  // 2. 获取所有标题元素
  const captionsEL = document.querySelectorAll(".slide-caption");
  // 3. 监听轮播事件：挂载后和滑动后执行入场动画
  glide.on(["mount.after", "run.after"], () => {
    // 获取当前显示的标题元素
    const caption = captionsEL[glide.index];
    if (caption) {
      // 使用 anime 为标题的子元素添加动画
      anime({
        targets: caption.children,
        opacity: [0, 1],
        duration: 400,
        easing: "spring(1, 80, 10, 0)",
        delay: anime.stagger(400, { start: 300 }),
        translateY: [anime.stagger([40, 10]), 0],
      });
    }
  });
  // 4. 监听滑动前事件：先隐藏所有标题
  glide.on("run.before", () => {
    document.querySelectorAll(".slide-caption > *").forEach((el) => {
      el.style.opacity = 0;
    });
  });
  // 5. 挂载轮播
  glide.mount();
  // 6. 保存实例以便清理
  glideInstance = glide;
});
// 7. 组件销毁时清理轮播实例
onUnmounted(() => {
  if (glideInstance) {
    glideInstance.destroy();
    glideInstance = null;
  }
});

//动画配置项（从下到上）
const staggeringOption = {
  delay: 300,
  distance: "50px",
  duration: 500,
  easing: "ease-in-out",
  origin: "bottom",
};

onMounted(() => {
  ScrollReveal().reveal(".feature", {
    ...staggeringOption,
    interval: 350,
  });
  // 删除：service-item 动画已移至 ServiceProcess 组件
});

// 数据展示部分
onMounted(() => {
  if (typeof ScrollReveal !== "undefined") {
    ScrollReveal().reveal(".data-section", {
      beforeReveal: () => {
        if (typeof anime !== "undefined") {
          anime({
            targets: ".data-piece .num",
            innerHTML: (el) => {
              return [0, el.innerHTML];
            },
            duration: 1500,
            round: 1,
            easing: "easeInExpo",
          });
        }
      },
    });
  }
});
</script>

<style scoped>
/* 轮播图 */
.glide {
  position: relative;
  z-index: 50;
  margin: 0 0 80px 0;
}

.glide__slide img {
  width: 100vw;
  height: 100vh;
  /* 自动等比例缩放 */
  object-fit: cover;
}

.slide-caption {
  position: absolute;
  z-index: 70;
  color: var(--text-color-lightest);
  text-align: center;
  max-width: 60vw;
}

.glide__slide {
  display: flex;
  align-items: center;
  justify-content: center;
}

.slide-caption h1 {
  font-size: 54px;
  font-weight: 600;
}

.slide-caption h3 {
  font-size: 24px;
  margin: 48px 0px;
}

.slide-caption.left {
  max-width: 80vw;
  text-align: left;
}

.slide-caption > * {
  opacity: 0;
}

.backdrop {
  background: var(--backdrop-color);
  z-index: 60;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  opacity: 0.2;
}

.explore-btn {
  padding: 14px 32px;
  background-color: var(--primary-color);
  border: 0;
  border-radius: 4px;
  color: var(--text-color-lightest);
  font-size: 18px;
  cursor: pointer;
  outline: none;
}

/* 内容区域 */
/* 通用样式 */
.content-wrapper {
  /* 一维排版 */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden; /* 防止内容溢出 */
}

section {
  /* 二维 */
  display: grid;
  /* 每个列的对齐方式 */
  justify-items: center;
  max-width: 1280px;
  padding: 0 80px;
}

.section-bg {
  position: relative;
}

.section-bg::before {
  content: "";
  display: block;
  position: absolute;
  background-color: #f9fbfb;
  width: 100vw;
  height: 100%;
  z-index: -1;
}

/* 为什么选择我们 */
.about-us {
  padding-bottom: 32px;
}

.features {
  display: grid;
  /* 重复几次，重复的值  1fr：容器宽度的1/3*/
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 126px 126px;
  column-gap: 5vw;
  /* 不添加 margin-top，由 StatsHeader 组件的 margin-bottom 控制间距 */
}

.feature {
  display: grid;
  grid-template-areas:
    "icon title"
    "icon content";
  grid-template-columns: 60px 1fr;
  grid-template-rows: 1fr 3fr;
}

.feature i.fas {
  grid-area: icon;
  font-size: 34px;
  color: var(--primary-color);
}

.feature-title {
  grid-area: title;
  font-size: 18px;
  color: var(--text-color-darker);
}

.feature-content {
  grid-area: content;
  color: var(--text-color-gray);
  margin-top: 8px;
}

/* 产品 */
.company-product {
  margin-top: 30px;
  padding-top: 72px;
  padding-bottom: 72px;
}

.products {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 24px;
}

.product {
  box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.1);
  padding: 24px;
  margin-bottom: 24px;
  transition: 0.4s;
}

.product-image-wrapper {
  height: 255px;
  overflow: hidden;
  margin: -24px;
  margin-bottom: 0;
}

.product-image-wrapper img {
  min-height: 300px;
  object-fit: cover;
}

.product .meta {
  margin-top: 20px;
  margin-bottom: 12px;
  color: var(--text-color-light-gray);
  font-size: 12px;
  display: flex;
}

.product .meta > p:last-child {
  margin-left: 36px;
}

.product-title {
  color: var(--text-color-dark);
  font-size: 18px;
  margin-bottom: 16px;
  margin-top: 16px;
}

.product article {
  color: var(--text-color-gray);
  letter-spacing: 0.54px;
  line-height: 24px;
}

.read-more-btn {
  border: 0;
  color: white;
  background-color: var(--primary-color);
  padding: 6px 14px;
  margin-top: 24px;
  border-radius: 4px;
  cursor: pointer;
}

.product:hover {
  transform: translateY(-20px) scale(1.05);
  box-shadow: 0px 0px 36px rgba(0, 0, 0, 0.1);
}

/* 数据展示 */
.data-section {
  max-width: unset;
  width: 100vw;
  height: 255px;
  background-image: url("../assets/images/background/data-bg.jpg");
  background-size: cover;
  background-position: center;
  display: grid;
  grid-template-columns: repeat(3, minmax(auto, 220px));
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 20;
  margin: 80px 0 0 0;
}

.data-section::before {
  content: "";
  display: block;
  position: absolute;
  background-color: var(--backdrop-color);
  width: 100%;
  height: 100%;
  z-index: 1;
}

.data-piece {
  width: 250px;
  display: grid;
  grid-template-rows: repeat(3, 1fr);
  justify-items: center;
  color: white;
  position: relative;
  z-index: 40;
}

.data-piece i.fas {
  font-size: 44px;
}

.data-piece .num {
  margin-top: 7px;
  font-size: 41px;
  font-weight: 600;
}

.data-piece .data-desc {
  font-size: 18px;
  font-weight: 500;
}

/* 响应式样式 - 平板端 (768px - 1024px) */
@media screen and (max-width: 1024px) {
  /* 轮播图字体适配，防止溢出 */
  .slide-caption h1 {
    font-size: 36px;
    line-height: 1.2;
  }
  .slide-caption h3 {
    font-size: 18px;
    margin: 24px 0;
    line-height: 1.4;
  }
  .slide-caption {
    max-width: 80vw;
  }
  .slide-caption.left {
    max-width: 90vw;
  }
  
  /* 通用间距调整 */
  section {
    padding: 0 40px;
  }
  
  /* 为什么选择我们 - 列数调整 */
  .features {
    grid-template-columns: repeat(2, 1fr);
    column-gap: 3vw;
  }
  
  /* 产品区域 - 列数调整 */
  .products {
    grid-template-columns: repeat(2, 1fr);
    column-gap: 16px;
  }
  
  /* 数据展示区域字体适配 */
  .data-piece .num {
    font-size: 32px;
  }
  .data-piece .data-desc {
    font-size: 16px;
  }
  .data-piece i.fas {
    font-size: 36px;
  }
}

/* 响应式样式 - 小于768px */
@media screen and (max-width: 767px) {
  /* 通用样式 */
  section {
    padding: 0 40px;
  }
  
  /* 为什么选择我们 - 竖式排列 */
  .features {
    grid-template-columns: 1fr; /* 单列 */
    grid-template-rows: auto;
    row-gap: 24px;
  }
  .feature {
    grid-template-areas:
      "icon"
      "title"
      "content";
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto;
    text-align: center;
    padding: 16px 0;
  }
  .feature i.fas {
    justify-self: center;
    margin-bottom: 8px;
  }
  
  /* 产品区域 - 竖式排列 */
  .products {
    grid-template-columns: 1fr; /* 单列 */
  }
  .product {
    margin-bottom: 32px;
  }
  .product-image-wrapper {
    height: 200px;
  }
  
  /* 数据展示区域 - 竖式排列 */
  .data-section {
    height: auto;
    padding: 40px 0;
    grid-template-columns: 1fr; /* 单列 */
    grid-template-rows: repeat(3, 1fr);
    row-gap: 32px;
  }
  .data-piece {
    width: 100%;
    padding: 16px 0;
  }
}

@media (max-width: 576px) {
  /* 轮播图 */
  .slide-caption h1 {
    font-size: 28px;
  }
  .slide-caption h3 {
    font-size: 14px;
  }
  .explore-btn {
    font-size: 14px;
    padding: 8px 18px;
  }
}
</style>